import React from 'react';
import Image from '@atlaskit/image';
import MagicSearchImage from '../../assets/magic-search.svg';

/** @deprecated Use @atlassian/jira-illustrations/src/ui/adg4/brand/spots/software/components/magic-search/index.tsx */
const MagicSearch = () => <Image src={MagicSearchImage} alt="Illustration for MagicSearch" />;

export { MagicSearch };
